import React from 'react';
import {
  FeedbackLoadingSpinnerProps,
  FeedbackLoadingOverlayProps,
} from '@/types/components';
import { Spinner } from '@/components/ui/spinner';

// Map this component's legacy API onto the Dash design-system Spinner.
const sizeMap = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
} as const;

const toneMap = {
  primary: 'primary',
  white: 'white',
  gray: 'neutral',
} as const;

export const FeedbackLoadingSpinner: React.FC<FeedbackLoadingSpinnerProps> = ({
  size = 'medium',
  className = '',
  color = 'primary',
}) => (
  <div className={`flex justify-center items-center ${className}`}>
    <Spinner size={sizeMap[size]} tone={toneMap[color]} />
  </div>
);

export const FeedbackLoadingOverlay: React.FC<FeedbackLoadingOverlayProps> = ({
  message = 'Loading...',
  isVisible = true,
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bg-strong-950/50">
      <div className="flex flex-col items-center rounded-2xl bg-bg-white-0 p-6 shadow-card-md">
        <Spinner size="xl" tone="primary" />
        <p className="mt-4 font-medium text-text-sub-600">{message}</p>
      </div>
    </div>
  );
};
